export const ROLES = 'admin/roles/all'
export const ROLE = 'admin/roles/edit'
export const CREATE_ROLE = 'admin/roles/add'
export const UPDATE_ROLE = 'admin/roles/update'
export const DELETE_ROLE = 'admin/roles/delete'

export const PERMISSIONS = 'admin/permissions/all'

export const MODULES = 'admin/modules/all'
